// //Get web worker instance
let initial = new Worker('/static/serialWorker.js', {
    type: 'module',
})

const workerReducer = (state = initial) => {
    return state
}
export default workerReducer
